import { useDownloadFile } from "@/api/file/useDownloadFile";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { Document } from "@/schema/Document";
import { ArrowDownload16Filled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface DocumentTableProps {
  data: Document[];
}

function DownloadButton({ path }: { path: string }) {
  const { trigger } = useDownloadFile(path, {
    onSuccess: (data) => {
      window.open(data.data.url, "_blank");
    },
  });

  return (
    <Button variant="ghost" onClick={() => trigger()}>
      <ArrowDownload16Filled />
    </Button>
  );
}

function DocumentTable({ data }: DocumentTableProps) {
  const { t } = useTranslation();

  return (
    <SimpleTable
      data={data}
      columns={[
        {
          key: "no",
          label: t("no."),
          width: "100px",
          render: (_, index) => `${index + 1}`,
        },
        {
          key: "name",
          label: t("file-name"),
          render: ({ file_name }) => file_name,
        },
        {
          key: "action",
          label: "",
          width: "100px",
          render: ({ file_path }) => <DownloadButton path={file_path} />,
        },
      ]}
    />
  );
}

export default DocumentTable;
